import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import moment from 'moment'

import { Label } from 'semantic-ui-react';

import {
  isNilOrEmpty
} from '_utils'

import Gravatar from '_views/gravatar'
const getDisplay = R.pathOr('', ['user', 'displayname'])
const getFull = R.pathOr('', ['user', 'full_name'])
const getEmail = R.pathOr('', ['user', 'email'])
const getLabel = R.compose(
  R.ifElse(
    isNilOrEmpty,
    R.always(null),
    label => (<div style={{paddingBottom: '0.4em', fontSize: '1.2em'}}><b>{label}</b></div>)
  ),
  R.prop('label')
)

const UserInfo = props => R.prop('user', props)
  ? (
    <Label as={props.onClick ? 'a' : null} onClick={props.onClick ? props.onClick : null}>
      <Gravatar
        gravatar={R.path(['user', 'gravatar'], props)}
        size={20}
        circular={true}
        style={{display: 'inline-block', verticalAlign: 'top', paddingRight: '0.5em'}}
      />
      <div style={{display: 'inline-block'}}>
        {getLabel(props)}
        <div>{getDisplay(props)}</div>
        <div>{getEmail(props)}</div>
        { getDisplay(props) !== getFull(props)
          ? <div>{getFull(props)}</div>
          : null
        }
        { props.date
          ? <div>{moment(props.date).format('YYYY-MM-DD')}</div>
          : null
        }
      </div>
    </Label>
  )
  : props.whenNull
    ? props.whenNull
    : null

UserInfo.propTypes = {
  user: PropTypes.object,
  onClick: PropTypes.func,
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  whenNull: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])

}
export default UserInfo



// WEBPACK FOOTER //
// ./webAdmin/views/userInfo.js